import { createRouter, createWebHistory } from 'vue-router'
import DashboardHome from '../views/DashboardHome.vue'
import AssetType from '../views/AssetType.vue'
import AssetView from '../views/AssetView.vue'
import VideoView from '../views/VideoView.vue'
import RenderView from '../views/RenderView.vue'
import AssetViewDetail from '../views/AssetViewDetail.vue'
import NotFoundComponent from '../views/NotFoundComponent.vue'
import { auth } from '../firebase'

const routes = [
  {
    path: '/',
    name: 'DashboardHome',
    component: DashboardHome,
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: '/asset/:assetType',
    name: 'AssetType',
    props: true,
    component: AssetType,
  },
  {
    path: '/asset/:assetType/:viewType/:lid?/:collectionId?',
    name: 'AssetView',
    props: true,
    component: AssetView,
  },
  {
    path: '/asset/view/video/:collectionId/:guid',
    name: 'VideoView',
    props: true,
    component: VideoView,
  },
  {
    path: '/asset/:assetType/:viewType/view/:order',
    name: 'AssetViewDetail',
    props: true,
    component: AssetViewDetail,
  },

  {
    path: '/asset/:assetType/:viewType/view/:order',
    name: 'RenderView',
    props: true,
    component: RenderView,
  },

  {
    path: '/:catchAll(.*)',
    component: NotFoundComponent,
    name: 'NotFound',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login' && auth.currentUser) {
    next('/')
    return
  }

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !auth.currentUser
  ) {
    next('/login')
    return
  }

  next()
})

export default router
